/**
 * @generated SignedSource<<8014d6a05835bf0d0e3900984a6503d6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4ProfileNew$data = {
  readonly user: {
    readonly email?: string | null | undefined;
    readonly picture: AGG$URL;
  } | null | undefined;
  readonly " $fragmentType": "Nav4ProfileNew";
};
export type Nav4ProfileNew$key = {
  readonly " $data"?: Nav4ProfileNew$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4ProfileNew">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "atlassianAccountId"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4ProfileNew",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "accountId",
          "variableName": "atlassianAccountId"
        }
      ],
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "picture"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "email"
            }
          ],
          "type": "AtlassianAccountUser"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "99761b04f3cd20bc2c9f267f5127e730";

export default node;
